import { makeStyles } from '@material-ui/core/styles'
import PasswordField from 'material-ui-password-field'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import TextField from '@material-ui/core/TextField'
import InputAdornment from '@material-ui/core/InputAdornment'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
import React from 'react'
import { Input } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%',
    fontWeight: 'bold',
    color: theme.palette.common.black,
    [theme.breakpoints.up('md')]: {
      width: '90%',
      fontSize: '14px',
      marginTop: '17px',
      padding: '8.5px',
    },
  },
  input2: {
    width: '100%',
    fontWeight: 'bold',
    color: theme.palette.common.black,
    [theme.breakpoints.up('md')]: {
      // width: '90%',
      fontSize: '14px',
      marginTop: '17px',
      padding: '8.5px',
    },
  },
  error: {
    border: '1px solid red',
  },
}))
export default function AuthInputField({
  className,
  handleChange,
  value,
  placeholder,
  type = 'text',
  errorMessage,
  onKeyDown,
  select,
  options,
  number,
  fieldValue = '', 
  fieldName = '',
  completeOption= false,
  handleLogin
  // placeholder
}) {
  const classes = useStyles()
  const handleOnChange = (event) => {
    handleChange(event.target.value)
    onKeyDown(event.target.value)
  }
  const handleNumber = (event) => {
    const re = /^[0-9\b]+$/
    if (event.target.value === '' || re.test(event.target.value)) {
      handleChange(event.target.value)
      onKeyDown()
    }
  }

  return (
    <>
      {select ? (
        <FormControl style={{ width: '100%' }} className={className}>
          <InputLabel id="demo-simple-select-label">{placeholder}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={value}
            onChange={handleOnChange}
            // style={{ minWidth: '100%' }}
            placeholder={placeholder}
            fullWidth={true}
          >
            {console.log({options})}
            {options &&
              options.map((item, index) => (
                <MenuItem key={index} value={completeOption? item: item[fieldValue]!== undefined ? item[fieldValue] : item.name}>
                  {fieldName!== '' ? item[fieldName] : item.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      ) : type === 'password' ? (
        <React.Fragment>
          <Input
            // floatingLabelText="Password"
            fullWidth
            onChange={number ? handleNumber : handleOnChange}
            value={value}
            label={placeholder}
            placeholder={placeholder}
            type="password"
            //onBlur={onKeyDown}
            className={className}
            error={errorMessage ? true : false}
            helperText={errorMessage ? errorMessage : ''}
          />
          <FormHelperText style={{ color: 'red' }}> {errorMessage ? errorMessage : ''}</FormHelperText>
        </React.Fragment>
      ) : (
        <div>
          <TextField
            type={type}
            value={value}
            onChange={number ? handleNumber : handleOnChange}
            label={placeholder}
            fullWidth={true}
            className={className}
            onBlur={onKeyDown}
            error={errorMessage ? true : false}
            helperText={errorMessage ? errorMessage : ''}
          // min={}
          />
          {/* <FormHelperText style={{ color: 'red' }}> {errorMessage ? errorMessage : ''}</FormHelperText> */}
        </div>
      )}
    </>
  )
}
